import React, { useState, useEffect } from 'react';
import '../css/App.css';


import AccordionTest from './AccordionComponents/AccordionTest';

import { SimpleGrid, Box, useToast, Flex, Text, SliderThumb, HStack, Button, Icon, IconButton, Tooltip, Spacer, Spinner, ModalCloseButton } from '@chakra-ui/react'
import { Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer } from '@chakra-ui/react'
import { FiRotateCw, FiX, FiArrowDownCircle, FiArrowUpCircle, FiFile, FiPlus, FiSettings, FiAlertCircle } from "react-icons/fi"

import AppText from '../lang_de.json';

import MapScreen from '../GlobalComponents/Map/MapScreen';
import WebsiteHeader from '../GlobalComponents/WebsiteHeader';
import BaseModal from '../GlobalComponents/BaseModal';



export default function ViewManifest(props) {
    const [LieferDetail, setLieferDetail] = useState(false);
    //const [LieferDetail, setLieferDetail] = useState({ Zustell_Zeit: 'thisDayAndAge', lat: 50.8203893000, long: 13.0812356000 });

    const [ShowCustomer, setShowCustomer] = useState(false);
    const [ShowAblade, setShowAblade] = useState(true);

    const [AbladeSt, setAbladeSt] = useState(0);
    const [LieferSt, setLieferSt] = useState(0);

    const [AnalyseModal, setAnalyseModal] = useState(false)
    const [AnalyseData, setAnalyseData] = useState(null);

    useEffect(() => {

        if (props.ActiveUser.User_Prefers !== null && props.ActiveUser.User_Prefers !== undefined && props.ActiveUser.User_Prefers.ShowLieferFirst) {
            setShowCustomer(true);
        }

    }, [props.ActiveUser]);

    useEffect(() => {

        props.viewCall('reload')

    }, [])

    function AccordionCall(command, value1, value2) {
        if (command === 'createPDF') {
            props.viewCall('createPDF', value1, value2);
        }
        if (command === 'setLiefer') {
            setLieferDetail(value1)
        }
    }
    async function MapCall(comand, value1, value2) {
        if (comand === 'setMap') {
            props.viewCall('setMap', value1)
        }
    }
    function makePaketCSV(Manifest) { props.viewCall('createPaketCSV', Manifest); }
    function makeBeladePDF(Manifest) { props.viewCall('createBeladePDF', Manifest); }
    function makePaketPDF(Manifest) { props.viewCall('createPaketPDF', Manifest); }
    function CustomerVisibility() {

        var Show = ShowCustomer
        setShowCustomer(!Show)
        props.viewCall('setFirst', !Show)
    }
    function AbladeVisibility() {

        var Show = ShowAblade
        setShowAblade(!Show)
    }
    function formatTime(time) {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = Math.floor(time % 60);

        if (isNaN(hours)) return '00:00:00'

        const parts = [
            hours.toString().padStart(2, "0"),
            minutes.toString().padStart(2, "0"),
            seconds.toString().padStart(2, "0"),
        ];

        return parts.join(":");
    }
    async function getAnalyseData() {

        setAnalyseModal(true)

        if (AnalyseData === null) {

            var result = await props.viewCall('analyseData', props.TourData[0]?.Manifest);
            if (result && Array.isArray(result)) {

                var data = result[0];

                let start;
                let end;
                let tourTime;
                let paketTime;

                if (data.Start_Zeit && data.End_Zeit) {
                    start = new Date(data.Start_Zeit);
                    end = new Date(data.End_Zeit);
                    tourTime = (end - start) / 1000;
                }
                if (data.startPaket && data.endPaket) {
                    start = new Date(data.startPaket);
                    end = new Date(data.endPaket);
                    paketTime = (end - start) / 1000;
                }

                if (paketTime && data.Amount) {

                    data.paketTime = paketTime

                    data.avgAbladeTime = paketTime / data.AbladeAmount

                    data.avgLieferTime = paketTime / data.LieferAmount

                    data.avgPaketTime = paketTime / data.Amount

                    const paketH = Math.round(data.Amount / (paketTime / 3600) * 100) / 100
                    data.avgPaketH = paketH

                }
                setAnalyseData(data);
            } else {

            }
        }
    }

    function formatUnitValue(value, units, factor, margin) {

        let unitIndex = 0

        while (
            value - factor * margin &&
            unitIndex < units.length - 1
        ) {
            value = value / factor
            unitIndex++;
        }

        let number = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(value)

        return number + ' ' + units[unitIndex];
    }

    return (
        <Flex flexDir='column' height='100vh'>
            <WebsiteHeader Text='TourPortal / Manifest Ansicht' onClick={() => props.viewCall('back')} server={props.server} User={props.ActiveUser} />

            <Flex flex={1} backgroundColor='#ccc' flexDirection='row' overflow='auto' minHeight="400px" minWidth="750px">

                <Flex flex={1} flexDirection='column' width='45%' m={1}>

                    <Flex flex={1} borderWidth={1} borderRadius={3} flexDirection="column" borderColor='#000' mb={1} bg='#fff' padding={2} minHeight='205px' maxHeight='205px' overflow='auto'>

                        <Flex mb={0} justifyContent='space-between'>

                            <Text fontSize={25} fontWeight={'bold'}>Manifest: {props.curentManifest?.Manifestnummer}</Text>
                            <Spacer />
                            <Tooltip label="Aufbereitete Tourdaten anzeigen" placement='top' hasArrow bg='#666' >
                                <Button bg='#1DA1F2' color='#fff' marginRight={'5px'} onClick={() => getAnalyseData()} display={props.UserRights.tour_analyse ? "flex" : "none"} isDisabled={props.curentManifest.Status !== 'complete'}
                                    borderRadius="7px" >Analyse</Button>
                            </Tooltip>
                            <Tooltip label="Diese Tour bearbeiten" placement='top' hasArrow bg='#666'>
                                <Button bg='#1DA1F2' color='#fff' onClick={() => props.viewCall('switch_e')} isDisabled={!props.UserRights.tour_manage_all && !props.UserRights.tour_manage}
                                    borderRadius="7px 0px 0px 7px" >Editor</Button>
                            </Tooltip>
                            <Text>{!props.UserRights.tour_manage_all || !props.UserRights.tour_manage}</Text>

                            <Tooltip label="Seite neu laden" placement='top' hasArrow bg='#666'>
                                <IconButton bg='#1DA1F2' color='#fff' width='55px' height='40px' ml='2px' borderRadius="0px 7px 7px 0px"
                                    onClick={() => props.viewCall('reload')}
                                    icon={<Icon as={FiRotateCw} color='#fff' boxSize={35} />} />
                            </Tooltip>
                        </Flex>

                        <Flex m={2} mb={0} flexWrap='wrap'>
                            {props.curentManifest?.Tour ? (
                                <>
                                    <Flex>
                                        <Flex flexDirection='column' marginRight={5}>
                                            <Text style={DataGridHead}>Fahrer:</Text>
                                            <Text style={DataGridHead}>Tour:</Text>
                                            <Text style={DataGridHead}>Abladestellen:</Text>
                                            <Text style={DataGridHead}>Lieferstellen:</Text>
                                            <Text style={DataGridHead}>Pakete:</Text>
                                            <Text style={DataGridHead}>Papier:</Text>
                                        </Flex>
                                        <Flex flexDirection='column' marginRight={10}>
                                            <Text style={DataGrid}>{props.curentManifest.Fahrer_Name}</Text>
                                            <Text style={DataGrid}>{props.curentManifest.Tour}</Text>
                                            <Text style={DataGrid}>{props.curentManifest.Ablade_Anzahl}</Text>
                                            <Text style={DataGrid}>{props.curentManifest.Liefer_Anzahl}</Text>
                                            <Text style={DataGrid}>{props.curentManifest.Pakete_Anzahl}</Text>
                                            <Text style={DataGrid}>{props.curentManifest.Papier_Anzahl}</Text>
                                        </Flex>
                                    </Flex>
                                    <Flex>
                                        <Flex flexDirection='column' marginRight={5}>
                                            <Text style={DataGridHead}>Datum:</Text>
                                            <Text style={DataGridHead}>Status:</Text>
                                            <Text style={DataGridHead}>Gestartet:</Text>
                                            <Text style={DataGridHead}>Beendet:</Text>
                                        </Flex>
                                        <Flex flexDirection='column'>
                                            <Text style={DataGrid}>{props.curentManifest.Datum}</Text>
                                            <Text style={DataGrid}>{props.curentManifest.Status}</Text>
                                            <Text style={DataGrid}>{props.curentManifest.Start_Zeit}</Text>
                                            <Text style={DataGrid}>{props.curentManifest.End_Zeit}</Text>
                                        </Flex>
                                    </Flex>
                                </>
                            ) : (null)}
                        </Flex>
                    </Flex>
                    <Box flex={2.5} borderWidth={1} borderRadius={3} borderColor='#000' bg='#fff'>
                        <MapScreen TourData={props.TourData} server={props.server}
                            computeRoute={{ polyline: props.RouteObj.computeRoutePoly, data: props.RouteObj.computeRouteData }}
                            realRoute={{ polyline: props.RouteObj.realRoutePoly, data: props.RouteObj.realRouteData }}
                            singleLieferSt={LieferDetail} editMap={false} AllowComputeRoute AllowRealRoute ShowDriver
                            ShowDriverData={props.DriverData} ActiveUser={props.ActiveUser} MapCall={MapCall} />
                    </Box>
                </Flex>

                <Flex flex={1} flexDirection="column" borderWidth={1} borderRadius={3} borderColor='#000' m={1} ml={0} bg='#fff' padding={2} width='55%' overflow='auto'>

                    <Flex flexWrap='wrap' justifyContent='space-between' alignItems='center' my={2}>
                        <HStack spacing={0.5} mx={2} mb={1}>
                            <Button bg='#1DA1F2' color='#fff' borderRadius={'5px 0px 0px 5px'} variant='outline' onClick={() => CustomerVisibility()} isDisabled={ShowAblade === false}>
                                {ShowCustomer ? ('Verstecke Kunden') : ('Zeige Kunden')}
                            </Button>
                            <Button bg='#1DA1F2' color='#fff' borderRadius={'0px 5px 5px 0px'} variant='outline' onClick={() => AbladeVisibility()}>
                                {ShowAblade ? ('Verstecke Abladestellen') : ('Zeige Abladestellen')}
                            </Button>
                        </HStack>
                        <HStack spacing={0.5} mx={2} mb={1}>
                            <Tooltip label="Das Manifest als PDF ausgeben" placement='top' hasArrow bg='#666'>
                                <Button colorScheme='green' borderRadius={'5px 0px 0px 5px'} onClick={() => makeBeladePDF(props.TourData[0]?.Manifest)}>
                                    Papier-Manifest Erstellen
                                </Button>
                            </Tooltip>
                            <Tooltip label="Die Beladeliste als PDF ausgeben" placement='top-start' hasArrow bg='#666'>
                                <Button colorScheme='green' borderRadius={'0px 5px 5px 0px'} onClick={() => makePaketPDF(props.TourData[0]?.Manifest)}>
                                    Beladeliste Erstellen
                                </Button>
                            </Tooltip>
                        </HStack>
                    </Flex>

                    <Flex flex={1} flexWrap='wrap' my={2} overflow='auto'>
                        <AccordionTest
                            TourData={props.TourData}
                            LieferData={props.TourData.length !== 0 && props.TourData[AbladeSt].Lieferstellen.length !== 0 ? props.TourData[AbladeSt].Lieferstellen[LieferSt].Pakete : []}
                            ShowCustomer={ShowCustomer}
                            ShowAblade={ShowAblade}
                            ManifestNr={props.TourData.length !== 0 ? props.TourData[0].Manifest : ''}
                            AccordionCall={AccordionCall}
                            server={props.server}
                            route={props.route + (props.TourData.length !== 0 ? "?manifest=" + props.TourData[0].Manifest : "")}
                        />
                    </Flex>
                </Flex>
            </Flex>

            <BaseModal isOpen={AnalyseModal} onClose={() => setAnalyseModal(false)}
                style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', padding: 3, flexDirection: 'column', minWidth: '700px', minHeight: '100px', padding: 10 }}
            >
                <Flex width='100%' height='40px' alignItems='center' justifyContent='space-between'>
                    <Text fontSize={25} fontWeight={'bold'}>Analysedaten Manifest: {props.TourData[0]?.Manifest}</Text>
                    <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='40px'
                        onClick={() => setAnalyseModal(false)}
                        icon={<Icon as={FiX} color='#fff' boxSize={30} />} />
                </Flex>
                {AnalyseData ? (
                    <Flex style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                        <TableContainer>
                            <Table size="md">
                                <Tbody>
                                    <Tr>
                                        <Td>Zeit aller Pakete</Td>
                                        <Td>{formatTime(AnalyseData.paketTime)}
                                            <Tooltip shouldWrapChildren label={AppText.info_pakage_time}
                                                placement='top' hasArrow bg='#fff' color='#222' fontSize={14} offset={[0, 3]} marginLeft={1.5} borderWidth={1} borderRadius={5}>
                                                <Icon marginLeft={2} marginTop='2px' as={FiAlertCircle} color="#666" boxSize={'15px'} />
                                            </Tooltip>
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td>Zeit pro Abladestelle</Td>
                                        <Td>{formatTime(AnalyseData.avgAbladeTime)}</Td>
                                    </Tr>
                                    <Tr>
                                        <Td>Zeit pro Lieferstelle</Td>
                                        <Td>{formatTime(AnalyseData.avgLieferTime)}</Td>
                                    </Tr>
                                    <Tr>
                                        <Td>Zeit pro Paket</Td>
                                        <Td>{formatTime(AnalyseData.avgPaketTime)}</Td>
                                    </Tr>
                                    <Tr>
                                        <Td>Pakete pro Stunde</Td>
                                        <Td>{AnalyseData.avgPaketH} p/h</Td>
                                    </Tr>
                                    <Tr>
                                        <Td>Statische Strecke Gesamtlänge</Td>
                                        <Td>{formatUnitValue(AnalyseData.Strecke, ['m', 'km'], 1000, 1)}
                                            <Tooltip shouldWrapChildren label={AppText.info_static_distance}
                                                placement='top' hasArrow bg='#fff' color='#222' fontSize={14} offset={[0, 3]} marginLeft={1.5} borderWidth={1} borderRadius={5}>
                                                <Icon marginLeft={2} marginTop='2px' as={FiAlertCircle} color="#666" boxSize={'15px'} />
                                            </Tooltip>
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td>Statische Strecke Fahrzeit</Td>
                                        <Td>{formatTime(AnalyseData.Static_Zeit)}
                                            <Tooltip shouldWrapChildren label={AppText.info_static_duration}
                                                placement='top' hasArrow bg='#fff' color='#222' fontSize={14} offset={[0, 3]} marginLeft={1.5} borderWidth={1} borderRadius={5}>
                                                <Icon marginLeft={2} marginTop='2px' as={FiAlertCircle} color="#666" boxSize={'15px'} />
                                            </Tooltip>
                                        </Td>
                                    </Tr>
                                </Tbody>
                            </Table>
                        </TableContainer>
                        <Tooltip label="Alle fertigen Pakete in einer Tabelle" placement='top' hasArrow bg='#666'>
                            <Button colorScheme='green' borderRadius={'5px'} marginTop={'10px'} onClick={() => makePaketCSV(props.TourData[0]?.Manifest)}>
                                Paket-CSV erstellen
                            </Button>
                        </Tooltip>
                    </Flex>
                ) : (
                    <Spinner thickness='6px' speed='1s' emptyColor='gray.200' color='blue.500' size='xl' />
                )}
            </BaseModal>
        </Flex >
    );
}

const DataGridHead = {
    fontSize: 18,
    marginTop: -2,
    fontWeight: 'bold',
    height: '25px'
}
const DataGrid = {
    fontSize: 18,
    marginTop: -2,
    height: '25px'

}

